import axios from 'axios';
import {
  GetQuestionSecretDataType,
  RecoveryMethodsPasswordType,
} from 'store/credentials/types';
import { getApiBaseUrl } from 'helpers/api';

const baseUrl = getApiBaseUrl();

export function getQuestionSecretApi(data: GetQuestionSecretDataType) {
  return axios.get(`${baseUrl}/params/questions?language=${data.language}`);
}

export function getRecoveryMethodsPasswordApi(
  payload: RecoveryMethodsPasswordType,
) {
  return axios.post(`${baseUrl}/user/v2/recoveryMethods/password`, payload);
}

export function forgotPasswordByEmailApi(data: {
  language: string;
  token: any;
}) {
  return axios.post(`${baseUrl}/user/forgotPassword/email`, null, {
    params: {
      language: data.language,
    },
    headers: {
      authorization: data.token,
    },
  });
}

export function forgotPasswordByPhoneApi(data: {
  language: string;
  token: any;
}) {
  return axios.post(`${baseUrl}/user/forgotPassword/phone`, null, {
    params: {
      language: data.language,
    },
    headers: {
      authorization: data.token,
    },
  });
}

export function verifyPinMethodForgotPasswordApi({
  pin,
  token,
}: {
  pin: string;
  token: any;
}) {
  return axios.post(`${baseUrl}/user/forgotPassword/verifyPin`, { pin, token });
}

export function verifyCinBdApi(data: any) {
  return axios.post(`${baseUrl}/user/recoveryMethods/login`, data);
}
export function forgotPwdByQuestionApi(payload: {
  token: string;
  id_question: string;
  response_question: string;
}) {
  return axios.post(`${baseUrl}/user/forgotPassword/question`, payload, {
    headers: {
      Authorization: ` ${payload.token}`,
    },
  });
}
export function sendMailForgotLoginApi(data: {
  login: string;
  email: string;
  language: string;
  token: string;
}) {
  return axios.post(
    `${baseUrl}/user/forgotLogin/sendLogin/${data.login}?email=${data.email}&language=${data.language}`,
    { token: data.token },
  );
}
export function updatePasswordApi({
  newPassword,
  confirmPassword,
  token,
  login,
}: {
  newPassword: string;
  confirmPassword: string;
  login: string;
  token: any;
}) {
  return axios.put(
    `${baseUrl}/user/changePassword/${login}`,
    {
      password: newPassword,
      repassword: confirmPassword,
    },
    {
      headers: {
        Authorization: ` ${token}`,
      },
    },
  );
}

export function changePasswordApi(data: {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  token: any;
}) {
  return axios.post(
    `${baseUrl}/user/settings/security/changePassword`,
    {
      oldPassword: data.currentPassword,
      password: data.newPassword,
      confirm: data.confirmPassword,
    },
    {
      headers: {
        Authorization: ` ${data.token}`,
      },
    },
  );
}

export function changeSecretQuestionApi(data: {
  password: string;
  id_question: string;
  questionResponse: string;
  token: any;
}) {
  const { token, ...dataToSend } = data;
  return axios.post(
    `${baseUrl}/user/settings/security/changeSecretQuestion`,
    dataToSend,
    {
      headers: {
        Authorization: ` ${token}`,
      },
    },
  );
}

export function enableNotificationsApi(data: any) {
  const { token, ...dataToSend } = data;
  return axios.put(`${baseUrl}/user/settings/notifications`, dataToSend, {
    headers: {
      Authorization: ` ${token}`,
    },
  });
}
